import React from "react";
import styled from "styled-components";
import SEO from "../components/SEO";
import NewsSection from "../components/sections/NewsSection";
import GalleryHeroCarousel from "../components/sections/GalleryHeroCarousel";
import CoursesSection from "../components/sections/CoursesSection";
import SponsorsMarquee from "../components/sections/SponsorsMarquee";
import OpeningHoursSection from "../components/sections/OpeningHoursSection";
import QuickLinks from "../components/QuickLinks";
const Section = styled.section`
  padding: 4rem 1.5rem;
  scroll-margin-top: 110px; /* sticky header */
`;

const SectionAlt = styled(Section)`
  background: #f7fafc;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: clamp(22px, 3vw, 36px);
  margin: 0 0 1rem 0;
  color: #111;
`;

const Text = styled.p`
  max-width: 780px;
  font-size: 16px;
  line-height: 1.6;
  color: #222;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
  margin-top: 1.5rem;
`;

const Card = styled.div`
  padding: 1.25rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
`;

const HomePage = () => {
  return (
    <>
      <SEO
        title="Hofors BGK"
        description="Bangolf & äventyrsgolf i Hofors – öppettider, priser, banor, nyheter och kontakt."
        keywords="hofors bgk, bangolf, äventyrsgolf, minigolf, hofors"
      />
<GalleryHeroCarousel
  title="Hofors BGK"
  subtitle="Bangolf & äventyrsgolf i Hofors – öppettider, priser, banor, nyheter och kontakt."
  folder="Lite bilder från våra banor"   // 👈 exakt samma text som i gallery.folder i Firestore
  limit={10}
  autoplayMs={5200}
/>
<SectionAlt>
  <Inner>
    <h2 style={{ fontSize: "clamp(22px, 3vw, 36px)", margin: 0 }}>Snabblänkar</h2>

    <QuickLinks
      items={[
        { id: "open-hours", label: "Öppettider", icon: "🕒" },
        { id: "courses", label: "Banor", icon: "⛳" },
        { id: "groups", label: "Grupper & kalas", icon: "🎉" },
        { id: "news", label: "Nyheter", icon: "📰" },
        { id: "sponsors", label: "Sponsorer", icon: "🤝" },
        { id: "contact", label: "Kontakt", icon: "📍" },
      ]}
    />  
  </Inner>
</SectionAlt>
{/* NYHETER (din Firestore + Swiper) */}
      <SectionAlt id="news">
        <Inner>
          <Title>Senaste nytt</Title>
          <NewsSection />
        </Inner>
      </SectionAlt>
      {/* ÖPPETTIDER & PRISER */}
      <section id="open-hours">
  <div style={{ maxWidth: 1200, margin: "0 auto", padding: "4rem 1.5rem" }}>
    <OpeningHoursSection yearLabel="2025" />
  </div>
</section>

      {/* BANOR */}
      <SectionAlt id="courses">
  <Inner>
    <Title>Våra banor</Title>
    <CoursesSection limit={36} />
  </Inner>
</SectionAlt>


      {/* GRUPPER & KALAS */}
      <Section id="groups">
        <Inner>
          <Title>Grupper & kalas</Title>
          <Text>
            Vill du boka för barnkalas, företagskväll eller förening? Vi hjälper dig att fixa ett bra upplägg.
          </Text>

          <Grid>
            <Card>
              <h3>Passar för</h3>
              <ul>
                <li>Barnkalas</li>
                <li>After Work</li>
                <li>Företag & föreningar</li>
              </ul>
            </Card>
            <Card>
              <h3>Bokning</h3>
              <p>E-post: Hoforsbangolf@gmail.com</p>
              <p>Telefon:  070 446 33 02

    </p>
            </Card>
          </Grid>
        </Inner>
      </Section>

      

      {/* SPONSORER */}
     <section id="sponsors">
  <div style={{ maxWidth: 1200, margin: "0 auto", padding: "4rem 1.5rem" }}>
    <h2 style={{ fontSize: "clamp(22px, 3vw, 36px)", margin: "0 0 1rem 0" }}>
      Sponsorer
    </h2>

    {/* Rullande rad */}
    <SponsorsMarquee speedSeconds={35} />

    {/* (Valfritt) din grid under */}
    {/* <SponsorsSection limit={12} showAllLink={true} /> */}
  </div>
</section>


      {/* KONTAKT */}
      <SectionAlt id="contact">
        <Inner>
          <Title>Kontakt & hitta hit</Title>
          <Grid>
            <Card>
              <h3>Kontakt</h3>
              <p>E-post:Hoforsbangolf@gmail.com</p>
              <p>Telefon: 070 446 33 02</p>
            </Card>
            <Card>
              <h3>Adresser</h3>
              <p>Bangolf centrum: Skolgatan 21, Hofors</p>
              <p>Äventyrsgolf: Västra Villagatan 50, Hofors</p>
            </Card>
          </Grid>
        </Inner>
      </SectionAlt>
    </>
  );
};

export default HomePage;
